<template>
  <div class="referral-code-section">
    <h6 class="referral-code-section__title">
      {{ $tc('MypagePage.MypageReferralCode.title') }}
    </h6>

    <div class="referral-code-section__code" @click="shareCode(code)">
      <span class="referral-code-section__code-value">{{ code }}</span>
      <i><img :src="require('@/assets/img/icon/icon_share.svg')" alt="" /></i>
    </div>

    <message-modal-section
      v-show="isOpenModal"
      :message="$tc('MypagePage.MypageReferralCode.share.successful')"
      @close="isOpenModal = false"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import MessageModalSection from '@/components/common/modal/MessageModalSection.vue'
import DeviceInfo from '@/util/DeviceInfo'
import Logger from '@/util/logger/Logger'

/**
 * マイページ: 紹介コード: 紹介コード表示セクション
 */
export default defineComponent({
  name: 'ReferralCodeSection',
  components: {
    MessageModalSection,
  },
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  setup() {
    const isOpenModal = ref(false)

    return {
      isOpenModal,
    }
  },
  methods: {
    /**
     * 紹介コードシェア
     * @param code
     */
    shareCode(code: string) {
      if (window.navigator.share) {
        if (DeviceInfo.isMobile()) {
          window.navigator
            .share({
              title: this.$tc('MypagePage.MypageReferralCode.share.title'),
              text: `${this.$tc('MypagePage.MypageReferralCode.share.text')}${code}`,
            })
            .then(() => {
              Logger.info('ReferralCodeSection#shareCode: Success shared referral code.')
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((err: any) => {
              Logger.error(
                `ReferralCodeSection#shareCode: Failed shared referral code. error: ${JSON.stringify(
                  err,
                )}`,
              )
            })
        } else {
          this.copyTextToClipboard(code)
          this.isOpenModal = true
        }
      } else {
        // Web Share API未対応ブラウザ向けのフォールバックを実装する。
        this.copyTextToClipboard(code)
      }
    },
    /**
     *  Web Share API未対応ブラウザ向けにテキストコピーを実装
     * @param textVal
     */
    copyTextToClipboard(textVal: string) {
      navigator.clipboard.writeText(textVal).then(() => {
        this.isOpenModal = true
      })
    },
  },
})
</script>

<style lang="scss" scoped>
.referral-code-section {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  margin: 0 auto;
  padding: 24px 16px 12px;
  text-align: center;

  &__title {
    width: 100%;
    font-weight: 500;
    font-size: 17px;
    line-height: 1.41;
    color: $black;
  }

  &__code {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px 10px;
    gap: 6px;
    width: 100%;
    height: 62px;
    border: 1px solid $black10;
    border-radius: 6px;
    color: $green-link;
    cursor: pointer;

    &-value {
      font-weight: 600;
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: 0.04em;
    }
  }
}
</style>
